<template>
  <div class="mit-maps-page mit-page">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title> Manage People
              <div class="spacer"></div>
              <MitPeopleNameSearch
                :people="people"
                @update:filteredPeople="updateFilteredPeople"
              />
            </v-card-title>
            <v-card-subtitle class="caption">Search for lab members</v-card-subtitle>
            <v-divider></v-divider>
            <MitManagePeopleList :people="filteredPeople" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MitManagePeopleList from '../../components/manage/MitManagePeopleList.vue';
import MitPeopleNameSearch from '../../components/manage/MitPeopleNameSearch.vue';
import MitPeopleService from '../../services/MitPeopleService';

export default {
  name: 'MitHRManagePeoplePage',
  components: {
    MitManagePeopleList,
    MitPeopleNameSearch,
  },
  data() {
    return {
      people: [],
      filteredPeople: [],
    };
  },
  created() {
    this.loadPeople();
  },
  methods: {
    async loadPeople() {
      try {
        const response = await MitPeopleService.getPeople();
        this.people = response;
        this.filteredPeople = response; 
      } catch (error) {
        console.error('Error loading people:', error);
      }
    },
    updateFilteredPeople(filteredList) {
      this.filteredPeople = filteredList;
    },
  },
};
</script>

<style lang="scss" scoped>
.mit-info-card {
  width: 100%;
  height: 100%;
}

.v-card-title {
  display: flex;
  align-items: center;
}

.spacer {
  flex: 1;
}
</style>
